import { render, staticRenderFns } from "./SelectYourArea.vue?vue&type=template&id=bf4e1336&scoped=true&"
import script from "./SelectYourArea.vue?vue&type=script&lang=js&"
export * from "./SelectYourArea.vue?vue&type=script&lang=js&"
import style0 from "./SelectYourArea.vue?vue&type=style&index=0&id=bf4e1336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4e1336",
  null
  
)

export default component.exports